/**
 * @name ValidateDataService
 * @description Servicio para validar diferentes tipos de datos
 * @author Ricardo Guerra
 */

/**
 * Función que valida si una lista cumple con los requisitos para poder ser enviada a autorización
 * @param {[]} array El arreglo a validar
 * @param {number} min Mínimo número de items en array
 * @param {number} max Máximo número de items en array
 * @param {number} total Total esperado de la suma de cierto valor en el array
 * @param {string} property Propiedad a sumar
 */
const validateList = (array, min, max, total, property) => {
  if (Array.isArray(array)) {
    if (array.length >= min && array.length <= max) {
      let sum = 0;
      array.forEach((item) => { sum += item[property]; });
      return sum === total;
    } else {
      return false;
    }
  } else {
    // console.log('Es necesario pasar como parametro un array'); 
    return false;
  }
};


export const ValidateDataService = {
  isCorrectList: validateList
};
